import { useFormContext } from 'react-hook-form';
import useParams from '../../../hooks/useParamsAndCookies';
import { URLParam } from '../../../Interfaces/system/params.interfaces';
import { parseDate, parseId } from '@/src/utils/param';
import { fetchAccountsPayablesFilters } from './APFilters';

const params: URLParam<fetchAccountsPayablesFilters>[] = [
  { label: 'reportType' },
  { label: 'account' },
  { label: 'info' },
  { label: 'vendors', isEncrypted: true, multiple: true, parse: parseId },
  { label: 'jobs', isEncrypted: true, multiple: true },
  { label: 'dates', multiple: true, parse: parseDate },
];

const formatFilters = (filters: Partial<fetchAccountsPayablesFilters>) => {
  return {
    ...filters,
    reportType: filters.reportType ?? '',
    dates: filters.dates
      ? filters.dates.map((date) => date?.toString() || null)
      : null,
  };
};

type APParamsProps = {
  changeCreateBatch: (data: boolean) => void;
};

const APParams = ({ changeCreateBatch }: APParamsProps) => {
  const { setValue } = useFormContext<fetchAccountsPayablesFilters>();
  useParams<fetchAccountsPayablesFilters>({
    tab: 'AP',
    params,
    extraParams: [
      {
        label: 'paymentBatch',
        change: (value) => {
          changeCreateBatch(value === 'true');
        },
      },
      {
        label: 'submittedID',
        change: (value) => {
          changeCreateBatch(true);
          setValue('submittedID', value);
        },
      },
    ],
    formatFilters,
    filterChanges: (values) => {
      const cookies = values as { dates: (string | null)[] };
      const { dates, ...otherFields } = cookies;
      const newCookies = otherFields as Record<string, unknown>;
      if (dates) {
        const start = new Date(dates[0] ?? '');
        const end = dates[1] ? new Date(dates[1]) : null;
        newCookies['dates'] = [start, end];
      }

      return newCookies;
    },
    afterReset: () => {
      changeCreateBatch(false);
    },
    cookieFiltersName: 'filters',
  });

  return <span />;
};

export default APParams;
